import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { Application } from '@content-platform/web/angular/shared/data-access/application-api';

/**
 * Component to display the application menu
 *
 * @export
 * @class ApplicationsMenuComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-applications-menu',
  templateUrl: './applications-menu.component.html',
  styleUrls: ['./applications-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ApplicationsMenuComponent implements OnInit {
  @Input() applications: Application[];
  @Output() switchApp = new EventEmitter<Application>();

  constructor() {}

  ngOnInit() {}
}
